<template>
  <el-dialog v-model="visibleDialog" :visible.sync="visibleDialog" @close="visibleDialog=false"
             :before-close="onBeforeClose"
             append-to-body
  >
    <div class="result-box">
      <img src="@/assets/images/border.png" class="border"/>
      <img src="@/assets/images/border2.png" class="border2"/>
      <div class="boxs">
        <div class="result-title">
          <div class="title-left">模拟结果总结</div>
          <div class="title-right">
            <!--            <img src="@/assets/images/m3.png"/>
                        <img src="@/assets/images/m1.png"/>-->
          </div>
        </div>
        <div class="result-ul" style="display: none">
          <div class="result-li">
            <div class="result-top">
              <div class="result-time">20:10</div>
              <div class="result-status">
                <div>未读</div>
                <div class="point">
                  <span></span>
                </div>
              </div>
            </div>
            <div class="result-text">
              <div class="text">“Creativity is allowing yourself to make mistakes. Design is knowing which ones to
                keep.” — Scott Adams “创造允许犯错，设计要知道保留哪些。” 如果你无法简洁的表达你的想法，那只说明你还不够了解它。
                “Because every person knows what he likes, every person thinks he is an expert on user
                interfaces.” — Paul Heckel “因为每个人都知道自己喜欢什么，所以每个人都觉得自己是用户界面专家。”
              </div>
              <div class="text-bt">查看全文</div>
            </div>
            <div class="result-bottom">
              <div class="result-left">
                <!--                <audio src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3" controls autoplay loop
                                       muted></audio>-->
              </div>
              <div class="result-right"><img src="@/assets/images/m2.png"/>复制</div>
            </div>
          </div>
          <div class="result-li">
            <div class="result-top">
              <div class="result-time">20:10</div>
              <div class="result-status active">
                <div>未读</div>
                <div class="point">
                  <span></span>
                </div>
                <!--已读人-->
                <div class="read-box">
                  <div>某人</div>
                  <div>某人</div>
                  <div>某人</div>
                  <span>丨 已读</span>
                </div>
              </div>
            </div>
            <div class="result-text">
              <div class="text active">“Creativity is allowing yourself to make mistakes. Design is knowing which ones
                to keep.” — Scott Adams “创造允许犯错，设计要知道保留哪些。” 如果你无法简洁的表达你的想法，那只说明你还不够了解它。
                “Because every person knows what he likes, every person thinks he is an expert on user
                interfaces.” — Paul Heckel “因为每个人都知道自己喜欢什么，所以每个人都觉得自己是用户界面专家。 Paul Heckel
                “因为每个人都知道自己喜欢什么，所以每个人都觉得自己是用户界面专家。 Paul Heckel
                “因为每个人都知道自己喜欢什么，所以每个人都觉得自己是用户界面专家。 Paul Heckel
                “因为每个人都知道自己喜欢什么，所以每个人都觉得自己是用户界面专家。 Paul Heckel
                “因为每个人都知道自己喜欢什么，所以每个人都觉得自己是用户界面专家。 Paul Heckel
                “因为每个人都知道自己喜欢什么，所以每个人都觉得自己是用户界面专家。”
              </div>
              <div class="text-bt">收起</div>
            </div>
            <div class="result-bottom">
              <div class="result-left">
                <!--                <audio src="https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3" controls autoplay loop
                                       muted></audio>-->
              </div>
              <div class="result-right"><img src="@/assets/images/m2.png"/>复制</div>
            </div>
          </div>
        </div>
        <div class="result-ul">
          <div class="result-li" v-for="row in messages">
            <div class="result-top">
              <div class="result-time">{{ row.createTimeFormat }}</div>
              <!--              <div class="result-status"><div>未读</div><div class="point"><span></span></div></div>-->
            </div>
            <div class="result-text">
              <div class="text">{{ row.message }}</div>
              <div class="text-bt" @click="popupFullDialog(row)">查看全文</div>
            </div>
          </div>
        </div>
        <div class="input-box">
          <div class="box-box">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="textarea"
              maxlength="10000"
              show-word-limit
            >
            </el-input>
            <div class="input-bottom">
<!--              <img src="@/assets/images/m5.png"/>-->
              <div class="input-bt" @click="btnSend" :hidden="btnSendLoading">
                <img src="@/assets/images/m4.png"/>发送至飞行员
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--查看全文-->
    <fulltextModal v-if="fulltextModalVisible" :visible.sync="fulltextModalVisible" :txt="txtSelected"/>
  </el-dialog>
</template>

<script>
import {listMessage, sendMessage} from "@/api/msg";
import fulltextModal from "@/components/summarize/fulltextModal.vue";

export default {
  components: {fulltextModal},
  model: {
    prop: 'txt',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    recordId: {
      type: String,
      required: true
    },
    txt: {
      type: String,
      required: true
    },
  },
  computed: {
    visibleDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
  },
  data() {
    return {
      textarea: this.txt,
      messages: [],
      fulltextModalVisible: false,
      txtSelected: '',
      btnSendLoading: false
    }
  },
  created() {
    console.log('resultModal.vue created')
    this.loadMessage()
  },
  methods: {
    async loadMessage() {
      console.log(['resultModal.vue loadMessage'])
      const {code, data} = await listMessage(this.recordId)
      this.messages = data
      console.log(['this.messages', code, this.messages])
    },
    async btnSend() {
      this.btnSendLoading = true
      const {code} = await sendMessage(this.recordId, this.textarea).finally(() => this.btnSendLoading = false)
      console.log(['result', this.recordId, code])
      if (code === 'A00000') {
        this.textarea = ''
        this.$emit('change', this.textarea)
        this.loadMessage()
      }
    },
    onBeforeClose(done) {
      this.$emit('change', this.textarea)
      done()
    },
    popupFullDialog(row) {
      this.txtSelected = row.message
      this.fulltextModalVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.border {
  width: 486px;
  position: absolute;
  left: 0;
  bottom: 0;
}

.border2 {
  width: 486px;
  position: absolute;
  right: 0;
  top: 0;
}

.boxs {
  z-index: 999;
  position: relative;
}

.input-box {
  padding: 12px 20px 28px 20px;

  .input-bottom {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 8px;

    img {
      width: 20px;
      cursor: pointer;
      margin-right: 16px;
      cursor: pointer;
    }

    .input-bt {
      border-radius: 4px;
      background: #AFC6F5;
      height: 26px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1656D7;
      font-size: 14px;
      cursor: pointer;

      img {
        margin-right: 4px;
        width: 12px;
      }
    }
  }

  .box-box {
    border-radius: 4px;
    border: 1px solid #525F89;
    padding: 12px;
  }

  /deep/ .el-input__count {
    background: transparent;
    bottom: -70px;
    right: -12px;
  }

  /deep/ .el-textarea__inner {
    background: transparent !important;
    border: none;
    resize: none;
    height: 75px !important;
    font-size: 16px;
    line-height: 24px;
  }
}

.result-top {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  .point {
    width: 10px;
    height: 10px;
    border: 1px solid #FFB93A;
    border-radius: 50%;
    margin-left: 6px;
    margin-top: 2px;
  }

  .result-status.active {
    color: #65C58C;

    .point {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #65C58C;

      span {
        width: 6px;
        height: 6px;
        background: #65C58C;
        border-radius: 50%;
        display: block;
      }
    }
  }

  .result-status {
    color: #FFB93A;
    font-size: 14px;
    display: flex;
    align-items: center;
    position: relative;

    .read-box:before {
      content: '';
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      left: -14px;
      border-top: 8px solid transparent;
      border-right: 8px solid rgba(0, 0, 0, 0.70);
      border-left: 8px solid transparent;
      border-bottom: 8px solid transparent;
    }

    .read-box {
      position: absolute;
      padding: 0 8px;
      border-radius: 2px;
      background: rgba(0, 0, 0, 0.70);
      display: flex;
      align-items: center;
      height: 24px;
      left: 60px;
      white-space: nowrap;
      width: auto;
      color: rgba(255, 255, 255, 0.80);
      font-size: 12px;

      div {
        margin-right: 8px;
      }

      span {
        color: rgba(255, 255, 255, 0.60);
      }
    }
  }

  .result-time {
    color: rgba(255, 255, 255, 0.60);
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 100% */
    margin-right: 12px;
  }
}

.result-ul {
  padding: 0 20px;
  height: 610px;
  overflow: auto;

  .result-li {
    margin-bottom: 24px;

    .result-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 12px;

      .result-left {
        audio {
          width: 189px;
          height: 36px;
        }
      }

      .result-right:hover {
        color: #fff;
        border: 1px solid #525F89;
      }

      .result-right {
        display: flex;
        align-items: center;
        border-radius: 4px;
        background: #393F52;
        color: rgba(255, 255, 255, 0.80);
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px; /* 100% */
        min-width: 60px;
        height: 24px;
        cursor: pointer;
        justify-content: center;

        img {
          width: 14px;
          margin-right: 2px;
        }
      }
    }

    .result-text {
      border-radius: 8px;
      border: 1px solid #525F89;
      padding: 16px 12px;
      background: #393f52;
      text-align: left;
      box-sizing: border-box;

      .text {
        color: rgba(255, 255, 255, 0.80);
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
        max-height: 220px;
        overflow: hidden;
      }

      .text.active {
        max-height: initial !important;
      }

      .text-bt {
        color: #3CA0E9;
        font-family: "PingFang SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px; /* 100% */
        cursor: pointer;
        margin-top: 14px;
      }
    }
  }
}

.result-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 20px;
  z-index: 999;

  .title-left {
    color: rgba(255, 255, 255, 0.80);
    font-family: "PingFang SC";
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 100% */
  }

  .title-right {
    display: flex;
    align-items: center;

    img {
      margin-left: 20px;
      width: 20px;
      cursor: pointer;
    }
  }
}

/deep/ .el-dialog {
  margin: 0 !important;
  box-shadow: 0px 23px 33px rgba(18, 21, 30, 0.794744);
  border-radius: 15px;
  border: 1px solid #1C2539;
  background: #262D40;
  width: 700px;
  height: 850px;
  position: absolute;
  right: 24px;

  .el-dialog__header {
    padding: 0;
    display: none;
  }

  .el-dialog__body {
    padding: 0;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/summarize/resultModal.vue